module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-badge', {
    staticClass: "erco-status-badge",
    attrs: {
      "variant": _vm.badgeVariant
    }
  }, [_vm._v(_vm._s(_vm.uppercasedStatus))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54c91e98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoStatusBadge.vue
// module id = 623
// module chunks = 0